import { Button, Layout, Tag, Text } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'
import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'

import { formatBidButtonLabel, formatBulkSpotQuoteItemTitle } from '../presenter/spotQuotePresenter'
import { BulkSpotQuoteTags } from './BulkSpotQuoteTags'
import { SpotQuoteBidDeadline } from './SpotQuoteBidDeadline'
import { type SpotQuoteCardProps } from './SpotQuoteCard'
import { StyledVerticalDivider } from './SpotQuoteCard.styles'

export function BulkSpotQuoteDesktopCard({
  expiredQuote,
  item,
  showDeadline,
  showShipper,
  onBidClick,
}: SpotQuoteCardProps) {
  const { lanes, shipper, isUnderNegotiation } = item
  const { soonestBidDeadline } = lanes

  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderColor="color-border"
      borderWidth="border-thin"
    >
      <Layout.Group align="center" justify="space-between">
        <Layout.Stack>
          <Layout.Group>
            <Text variant="heading-sm-bold">{formatBulkSpotQuoteItemTitle(lanes)}</Text>
            <BulkSpotQuoteTags item={item} />
          </Layout.Group>
          <Layout.Group align="center">
            {showShipper && (
              <ShipperInformation
                companyName={shipper.companyName}
                contactName={shipper.name}
                email={shipper.email}
                logo={shipper.logoUrl}
                phone={shipper.phoneNumber}
              />
            )}
            {showDeadline && (
              <>
                <StyledVerticalDivider />
                <SpotQuoteBidDeadline
                  deadline={soonestBidDeadline}
                  isExpired={expiredQuote}
                  isMultiline
                  isBulkQuote
                />
              </>
            )}
          </Layout.Group>
        </Layout.Stack>
        <Layout.Stack align="flex-end" style={{ marginTop: isUnderNegotiation ? 'unset' : 'auto' }}>
          {isUnderNegotiation && (
            <Tag variant="warning" leading={<Icon name="attention" />}>
              Counter-offer received
            </Tag>
          )}
          <Button type="button" variant="secondary" onClick={onBidClick}>
            {formatBidButtonLabel({ isUnderNegotiation, isBulkQuote: true })}
          </Button>
        </Layout.Stack>
      </Layout.Group>
    </Layout.Box>
  )
}
